import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { SubDivision } from "@app/models/rest/roster/sub-division";
import { SubDivisionRestService } from "@app/services/hal/roster/sub-division-rest-service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class SubDivisionStore extends RealTimeDataStore<SubDivision> {
  constructor() {
    const subDivisionRestService = inject(SubDivisionRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(subDivisionRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("SubDivision");
  }
}
